<script setup lang="ts">
import RvApi, { type PlatformMessages } from "@/rvapi";
import MessageRows from "./MessageRows.vue";
import { ref, onMounted } from "vue";
import config from "@/config";

const props = defineProps<{
  platform: string;
}>();
const messages = ref({ info: [], critical: [] } as PlatformMessages);
const loading = ref(true);

const refresh = async () => {
  const url = `${config.systemStatusBucket}/${
    props.platform
  }.json?${Math.random().toString()}`;
  messages.value = await RvApi.raw(url);
  loading.value = false;
};

const deleteMessage = async (id?: string) => {
  if (!id) {
    throw "cant delete without id";
  }
  loading.value = true;
  await RvApi.deleteSystemStatusMesssage(props.platform, id);
  await refresh();
};

onMounted(async () => {
  await refresh();
});

defineExpose({ refresh });
</script>

<template>
  <h2>{{ platform }}</h2>
  <div class="loading" v-show="loading">
    <pn-spinner size="2" />
  </div>
  <div class="messages" v-show="!loading">
    <pn-table bordered="true" striped="true">
      <table>
        <thead>
          <tr>
            <th>Created</th>
            <th>Level</th>
            <th>Visible from</th>
            <th>Visible to</th>
            <th>Version</th>
            <th>Views</th>
            <th>Message (en)</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <MessageRows
            :platform="props.platform"
            @delete="deleteMessage"
            :rows="messages.critical"
          />
          <MessageRows
            :platform="props.platform"
            @delete="deleteMessage"
            :rows="messages.info"
          />
        </tbody>
      </table>
    </pn-table>
  </div>
</template>
